export type CalendarStatus =
  | "pending_confirmation"
  | "confirmed"
  | "completed"
  | "cancelled"
  | "no_show";

export type CalendarAction = "confirm" | "cancel" | "complete" | "no_show" | "reschedule";

export function allowedActionsForStatus(status: string): CalendarAction[] {
  switch (status) {
    case "pending_confirmation":
      return ["confirm", "cancel", "reschedule"];
    case "confirmed":
      return ["complete", "no_show", "cancel", "reschedule"];
    default:
      return [];
  }
}

export function primaryActionForStatus(status: string): CalendarAction | null {
  if (status === "pending_confirmation") return "confirm";
  if (status === "confirmed") return "complete";
  return null;
}

export function nextStatusFromAction(current: string, action: CalendarAction): string {
  if (action === "reschedule") return current;
  if (action === "confirm") return "confirmed";
  if (action === "cancel") return "cancelled";
  if (action === "complete") return "completed";
  if (action === "no_show") return "no_show";
  return current;
}

export function riskRank(tier?: string | null): number {
  if (tier === "high") return 3;
  if (tier === "medium") return 2;
  if (tier === "low") return 1;
  if (tier === "minimal") return 0;
  return -1;
}

